import React from "react";
import './Video.css';

const VideoDetail = ({ video }) => {
	if (!video) {
		return <div>

		</div>;
	}

	const videoSrc = `https://www.youtube.com/embed/${video.id.videoId}`;
	console.log(typeof video);
	return (
		<div className=''>
			<div>
				<iframe  className="selectedVideo" src={videoSrc} allowFullScreen title="Video player" />
			</div>
			<div className="ui segment">
				<h4 className="ui header">{(video.snippet.title)}</h4>

			</div>
		</div>
	);
};

export default VideoDetail;